// 고객 액션(rpc) — 셸의 빠른 견적 시작이 쓴다.
import { rpc } from "@/api/client";

export const startQuote = (customerId: string) => rpc("customer/actions/startQuote", customerId);

export const startRoughQuote = (customerId: string) => rpc("customer/actions/startRoughQuote", customerId);

export const createCustomer = (form: FormData) => rpc("customer/actions/createCustomer", form);

export const updateCustomer = (customerId: string, form: FormData) => rpc("customer/actions/updateCustomer", customerId, form);

export const markCustomerContacted = (customerId: string) => rpc("customer/actions/markCustomerContacted", customerId);

export const markCustomerLost = (customerId: string, lostReason: string) => rpc("customer/actions/markCustomerLost", customerId, lostReason);

export const revertCustomerStage = (customerId: string, reason: string) => rpc("customer/actions/revertCustomerStage", customerId, reason);

export const saveUnansweredHours = (input: unknown) => rpc("customer/unanswered-actions/saveUnansweredHours", input);

export const submitIntake = (slug: string, form: FormData) => rpc("customer/intake-actions/submitIntake", slug, form);
